/* Throttle Ranch — Desert Dash mini game. Just for fun; scores earn nothing. */
(function () {
  'use strict';

  function css(el, name, fallback) {
    var v = getComputedStyle(el).getPropertyValue(name).trim();
    return v || fallback;
  }

  function store(key, val) {
    try {
      if (val === undefined) return parseInt(localStorage.getItem(key), 10) || 0;
      localStorage.setItem(key, String(val));
    } catch (e) { return 0; }
  }

  function init(wrap) {
    var canvas = wrap.querySelector('canvas');
    var ctx = canvas.getContext('2d');
    var scoreEl = wrap.parentNode.querySelector('[data-game-score]');
    var bestEl = wrap.parentNode.querySelector('[data-game-best]');
    var BEST_KEY = 'tr-desert-dash-best';

    var C = {
      sky: css(wrap, '--c-sand', '#EAD9B9'),
      ink: css(wrap, '--c-sand-ink', '#2A1C12'),
      accent: css(wrap, '--c-accent', '#D9661F'),
      sage: css(wrap, '--c-sage', '#8FA071'),
      dirt: '#B9875A',
      dirtDark: '#8E6440',
      mesa: '#C79A6C',
      mesaFar: '#D9BC92'
    };

    var H = 360;            // world height in game units
    var GROUND = 292;       // ground line
    var W = 960;            // world width (recomputed on resize)
    var scale = 1;

    var state = 'ready';    // ready | run | crash
    var t = 0, speed, dist, best = store(BEST_KEY);
    var bike, obstacles, particles, nextGap, holding = false, holdTime = 0;
    var raf = null, last = 0, visible = true, flash = 0;
    var cleared = 0, runStart = 0, sessionBest = null;
    var section = wrap.closest('section') || document;
    var form = section.querySelector('[data-dd-form]');

    bestEl && (bestEl.textContent = best);

    function resize() {
      var r = canvas.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(r.width * dpr);
      canvas.height = Math.round(r.height * dpr);
      scale = canvas.height / H;
      W = canvas.width / scale;
      ctx.setTransform(scale, 0, 0, scale, 0, 0);
      if (state !== 'run') draw();
    }

    function reset() {
      speed = 6.2;
      dist = 0;
      t = 0;
      bike = { x: Math.min(150, W * 0.2), y: GROUND, vy: 0, rot: 0, onGround: true, wheel: 0 };
      obstacles = [];
      particles = [];
      nextGap = 520;
      cleared = 0;
      runStart = performance.now();
    }

    function jump() {
      if (state === 'ready' || state === 'crash') { start(); return; }
      if (bike.onGround) {
        bike.vy = -11.4;
        bike.onGround = false;
        holdTime = 0;
        for (var i = 0; i < 8; i++) puff(bike.x - 30, GROUND, 2.2);
      }
    }

    function start() {
      reset();
      state = 'run';
      last = performance.now();
      loop(last);
    }

    function crash() {
      state = 'crash';
      flash = 1;
      var score = Math.floor(dist);
      recordRun({ score: score, ms: Math.round(performance.now() - runStart), cleared: cleared });
      if (score > best) { best = score; store(BEST_KEY, best); }
      bestEl && (bestEl.textContent = best);
      for (var i = 0; i < 24; i++) puff(bike.x, bike.y - 20, 5);
      draw();
    }

    var KINDS = [
      { k: 'hay', w: 46, h: 32 },
      { k: 'cactus', w: 28, h: 58 },
      { k: 'tires', w: 38, h: 44 },
      { k: 'rock', w: 54, h: 24 }
    ];

    function spawn() {
      var o = KINDS[Math.floor(Math.random() * KINDS.length)];
      obstacles.push({ k: o.k, w: o.w, h: o.h, x: W + 40 });
      // occasional double later in the run
      if (dist > 600 && Math.random() < 0.22) {
        var o2 = KINDS[Math.floor(Math.random() * 2)];
        obstacles.push({ k: o2.k, w: o2.w, h: o2.h, x: W + 40 + o.w + 6 });
      }
      var minGap = 260 + speed * 22;
      nextGap = minGap + Math.random() * 360;
    }

    function puff(x, y, power) {
      particles.push({
        x: x, y: y,
        vx: -Math.random() * power - speed * 0.2,
        vy: -Math.random() * power,
        r: 3 + Math.random() * 5,
        life: 1
      });
    }

    function update(dt) {
      t += dt;
      speed = Math.min(15, 6.2 + dist / 520);
      var move = speed * dt * 60 / 1000 * 1.0;
      dist += move / 8;
      scoreEl && (scoreEl.textContent = Math.floor(dist));

      // bike physics (units per 1/60s frame)
      var f = dt * 60 / 1000;
      if (!bike.onGround) {
        var g = 0.62;
        if (holding && bike.vy < 0 && holdTime < 220) { g = 0.3; holdTime += dt; }
        bike.vy += g * f;
        bike.y += bike.vy * f;
        bike.rot += ((bike.vy < 0 ? -0.32 : 0.18) - bike.rot) * 0.12 * f;
        if (bike.y >= GROUND) {
          bike.y = GROUND; bike.vy = 0; bike.onGround = true;
          for (var i = 0; i < 6; i++) puff(bike.x - 20, GROUND, 2.5);
        }
      } else {
        bike.rot += (-0.04 - bike.rot) * 0.2 * f;
        if (Math.random() < 0.5) puff(bike.x - 34, GROUND - 2, 1.4);
      }
      bike.wheel += move * 0.12;

      // obstacles
      nextGap -= move;
      if (nextGap <= 0) spawn();
      for (var j = obstacles.length - 1; j >= 0; j--) {
        var o = obstacles[j];
        o.x -= move;
        if (!o.passed && o.x + o.w < bike.x - 30) { o.passed = true; cleared++; }
        if (o.x + o.w < -60) { obstacles.splice(j, 1); continue; }
        // hitbox: bike body roughly 64 x 40 above wheels
        var bx1 = bike.x - 30, bx2 = bike.x + 28, by2 = bike.y - 4, by1 = bike.y - 44;
        var ox1 = o.x + 5, ox2 = o.x + o.w - 5, oy1 = GROUND - o.h + 5;
        if (bx2 > ox1 && bx1 < ox2 && by2 > oy1 && by1 < GROUND) { crash(); return; }
      }

      // particles
      for (var p = particles.length - 1; p >= 0; p--) {
        var q = particles[p];
        q.x += q.vx * f; q.y += q.vy * f; q.vy += 0.05 * f; q.life -= 0.025 * f;
        if (q.life <= 0) particles.splice(p, 1);
      }
    }

    /* ---------- drawing ---------- */

    function sky() {
      var grad = ctx.createLinearGradient(0, 0, 0, GROUND);
      grad.addColorStop(0, C.sky);
      grad.addColorStop(1, '#F3C98E');
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, W, GROUND);
      // sun
      ctx.fillStyle = C.accent;
      ctx.globalAlpha = 0.85;
      ctx.beginPath(); ctx.arc(W - 150, 90, 44, 0, Math.PI * 2); ctx.fill();
      ctx.globalAlpha = 1;
    }

    function mesas(offset, color, baseY, seed) {
      ctx.fillStyle = color;
      var span = 520;
      var x0 = -((offset) % span) - span;
      for (var x = x0; x < W + span; x += span) {
        ctx.beginPath();
        ctx.moveTo(x, GROUND);
        ctx.lineTo(x + 40, baseY);
        ctx.lineTo(x + 170 + seed, baseY);
        ctx.lineTo(x + 200 + seed, baseY + 24);
        ctx.lineTo(x + 290, baseY + 24);
        ctx.lineTo(x + 320, baseY - 14 + seed / 4);
        ctx.lineTo(x + 400, baseY - 14 + seed / 4);
        ctx.lineTo(x + 450, GROUND);
        ctx.closePath();
        ctx.fill();
      }
    }

    function saguaro(x, base, s, color) {
      ctx.fillStyle = color;
      ctx.strokeStyle = color;
      ctx.lineCap = 'round';
      ctx.lineWidth = 12 * s;
      ctx.beginPath(); ctx.moveTo(x, base); ctx.lineTo(x, base - 70 * s); ctx.stroke();
      ctx.lineWidth = 8 * s;
      ctx.beginPath(); ctx.moveTo(x, base - 30 * s); ctx.lineTo(x - 18 * s, base - 30 * s); ctx.lineTo(x - 18 * s, base - 52 * s); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(x, base - 40 * s); ctx.lineTo(x + 16 * s, base - 40 * s); ctx.lineTo(x + 16 * s, base - 60 * s); ctx.stroke();
    }

    function ground(offset) {
      ctx.fillStyle = C.dirt;
      ctx.fillRect(0, GROUND, W, H - GROUND);
      ctx.fillStyle = C.dirtDark;
      ctx.fillRect(0, GROUND, W, 4);
      // ruts
      var span = 46;
      for (var x = -(offset % span); x < W; x += span) {
        ctx.fillRect(x, GROUND + 18, 22, 3);
        ctx.fillRect(x + 18, GROUND + 38, 14, 3);
      }
      // checker strip at bottom
      var sq = 10, y = H - sq * 2;
      for (var cx = -(offset % (sq * 2)); cx < W; cx += sq) {
        for (var r = 0; r < 2; r++) {
          var on = (Math.floor((cx + offset) / sq) + r) % 2 === 0;
          ctx.fillStyle = on ? C.ink : '#F4E8D3';
          ctx.fillRect(cx, y + r * sq, sq, sq);
        }
      }
    }

    function obstacle(o) {
      var x = o.x, y = GROUND;
      if (o.k === 'hay') {
        ctx.fillStyle = '#D9B45A';
        ctx.fillRect(x, y - o.h, o.w, o.h);
        ctx.fillStyle = '#B18E3E';
        ctx.fillRect(x, y - o.h + 9, o.w, 3);
        ctx.fillRect(x, y - o.h + 21, o.w, 3);
      } else if (o.k === 'cactus') {
        saguaro(x + o.w / 2, y, 0.82, C.sage);
      } else if (o.k === 'tires') {
        ctx.fillStyle = '#2B2420';
        for (var i = 0; i < 3; i++) {
          ctx.fillRect(x, y - 15 * (i + 1) + 1, o.w, 13);
          ctx.fillStyle = i % 2 ? '#2B2420' : '#3A312B';
        }
        ctx.fillStyle = C.accent;
        ctx.fillRect(x + o.w / 2 - 3, y - o.h, 6, 4);
      } else {
        ctx.fillStyle = '#9C7F66';
        ctx.beginPath();
        ctx.moveTo(x, y); ctx.lineTo(x + 8, y - o.h); ctx.lineTo(x + o.w - 14, y - o.h + 3);
        ctx.lineTo(x + o.w, y); ctx.closePath(); ctx.fill();
      }
    }

    function wheel(x, y, r, a) {
      ctx.fillStyle = '#1C1612';
      ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#6B6460';
      ctx.beginPath(); ctx.arc(x, y, r * 0.55, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = '#1C1612';
      ctx.lineWidth = 2;
      for (var i = 0; i < 3; i++) {
        var ang = a + i * Math.PI / 3;
        ctx.beginPath();
        ctx.moveTo(x + Math.cos(ang) * r * 0.55, y + Math.sin(ang) * r * 0.55);
        ctx.lineTo(x - Math.cos(ang) * r * 0.55, y - Math.sin(ang) * r * 0.55);
        ctx.stroke();
      }
    }

    function drawBike() {
      ctx.save();
      ctx.translate(bike.x, bike.y - 14);
      ctx.rotate(bike.rot);
      // wheels
      wheel(-28, 0, 14, bike.wheel);
      wheel(28, 0, 14, bike.wheel);
      // swingarm + fork
      ctx.strokeStyle = '#3A312B'; ctx.lineWidth = 4; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(-28, 0); ctx.lineTo(-4, -12); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(28, 0); ctx.lineTo(18, -30); ctx.stroke();
      // battery / body
      ctx.fillStyle = '#2B2420';
      ctx.fillRect(-12, -24, 26, 14);
      // plastics
      ctx.fillStyle = C.accent;
      ctx.beginPath();
      ctx.moveTo(-34, -22); ctx.lineTo(-6, -26); ctx.lineTo(16, -30); ctx.lineTo(24, -24);
      ctx.lineTo(8, -20); ctx.lineTo(-30, -16); ctx.closePath(); ctx.fill();
      // front fender + number plate
      ctx.beginPath(); ctx.moveTo(20, -14); ctx.lineTo(40, -12); ctx.lineTo(24, -10); ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#F4E8D3';
      ctx.fillRect(14, -40, 8, 10);
      // bars
      ctx.strokeStyle = '#1C1612'; ctx.lineWidth = 3;
      ctx.beginPath(); ctx.moveTo(14, -36); ctx.lineTo(8, -44); ctx.stroke();
      // rider
      ctx.strokeStyle = C.ink; ctx.lineWidth = 7;
      ctx.beginPath(); ctx.moveTo(-6, -28); ctx.lineTo(4, -46); ctx.stroke();   // torso
      ctx.lineWidth = 5;
      ctx.beginPath(); ctx.moveTo(4, -44); ctx.lineTo(10, -44); ctx.stroke();  // arm
      ctx.beginPath(); ctx.moveTo(-6, -28); ctx.lineTo(6, -22); ctx.lineTo(4, -14); ctx.stroke(); // leg
      // helmet
      ctx.fillStyle = C.sage;
      ctx.beginPath(); ctx.arc(7, -54, 8, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = C.accent;
      ctx.fillRect(9, -59, 9, 3); // visor
      ctx.restore();
    }

    function overlay(title, sub) {
      ctx.fillStyle = 'rgba(30,20,12,0.55)';
      ctx.fillRect(0, 0, W, H);
      ctx.textAlign = 'center';
      ctx.fillStyle = '#F4E8D3';
      ctx.font = '900 54px "Saira Extra Condensed", "Arial Narrow", sans-serif';
      ctx.fillText(title, W / 2, H / 2 - 6);
      ctx.font = '600 20px Archivo, system-ui, sans-serif';
      ctx.fillStyle = '#EAD9B9';
      ctx.fillText(sub, W / 2, H / 2 + 30);
      ctx.textAlign = 'left';
    }

    function draw() {
      if (!bike) reset();
      var off = dist * 8;
      sky();
      mesas(off * 0.15, C.mesaFar, 180, 20);
      mesas(off * 0.35 + 200, C.mesa, 212, 0);
      // background cacti
      var span = 300;
      for (var x = -((off * 0.6) % span); x < W + 40; x += span) saguaro(x + 120, GROUND, 0.6, '#A3936B');
      ground(off);
      for (var i = 0; i < obstacles.length; i++) obstacle(obstacles[i]);
      // dust
      for (var p = 0; p < particles.length; p++) {
        var q = particles[p];
        ctx.fillStyle = 'rgba(185,135,90,' + (q.life * 0.7).toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(q.x, q.y, q.r, 0, Math.PI * 2); ctx.fill();
      }
      drawBike();

      // score in-canvas
      ctx.fillStyle = C.ink;
      ctx.font = '900 28px "Saira Extra Condensed", "Arial Narrow", sans-serif';
      ctx.fillText(Math.floor(dist) + ' FT', 20, 40);

      if (flash > 0) {
        ctx.fillStyle = 'rgba(217,102,31,' + (flash * 0.35).toFixed(3) + ')';
        ctx.fillRect(0, 0, W, H);
      }
      if (state === 'ready') overlay('DESERT DASH', 'Tap, click, or press Space to ride · Hold to jump higher');
      if (state === 'crash') overlay('YARD SALE!', Math.floor(dist) + ' ft · Best ' + best + ' ft · Tap to ride again');
    }

    function loop(now) {
      if (state !== 'run' || !visible) { raf = null; return; }
      var dt = Math.min(40, now - last);
      last = now;
      update(dt);
      draw();
      if (state === 'run') raf = requestAnimationFrame(loop);
      else raf = null;
    }

    function fadeFlash() {
      if (flash <= 0) return;
      flash = Math.max(0, flash - 0.08);
      draw();
      requestAnimationFrame(fadeFlash);
    }

    /* ---------- monthly high score submission ---------- */
    function monthLabel() {
      try {
        return new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', month: 'long', year: 'numeric' }).format(new Date());
      } catch (e) { return new Date().toISOString().slice(0, 7); }
    }
    // Light tamper check for the store owner (not real security): recompute with the same formula to compare.
    function checkCode(r, month) {
      var str = r.score + '|' + r.ms + '|' + r.cleared + '|' + month + '|throttle-ranch-dd';
      var h = 5381;
      for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
      return h.toString(36).toUpperCase();
    }
    function recordRun(r) {
      if (!sessionBest || r.score > sessionBest.score) sessionBest = r;
      if (!form) return;
      var month = monthLabel();
      var set = function (k, v) { var el = form.querySelector('[data-dd-field="' + k + '"]'); if (el) el.value = v; };
      set('score', sessionBest.score);
      set('time', (sessionBest.ms / 1000).toFixed(1));
      set('cleared', sessionBest.cleared);
      set('month', month);
      set('check', checkCode(sessionBest, month));
      form.querySelectorAll('[data-dd-show="score"]').forEach(function (el) { el.textContent = sessionBest.score.toLocaleString(); });
      form.querySelectorAll('[data-dd-show="month"]').forEach(function (el) { el.textContent = month; });
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = sessionBest.score < 1;
      var panel = section.querySelector('[data-dd-panel]');
      if (panel) panel.classList.add('is-ready');
    }
    if (form) {
      form.addEventListener('submit', function () {
        try {
          var email = form.querySelector('[name="contact[email]"]');
          var opt = form.querySelector('[data-dd-optin]');
          sessionStorage.setItem('tr-dd-email', email ? email.value : '');
          sessionStorage.setItem('tr-dd-optin', opt && opt.checked ? '1' : '');
        } catch (e) {}
      });
    }

    /* ---------- input ---------- */
    function press(e) {
      if (e) e.preventDefault();
      holding = true;
      var wasCrash = state === 'crash';
      jump();
      if (wasCrash) flash = 0;
    }
    function release() { holding = false; }

    canvas.addEventListener('pointerdown', press);
    window.addEventListener('pointerup', release);
    canvas.addEventListener('keydown', function (e) {
      if (e.code === 'Space' || e.code === 'ArrowUp' || e.code === 'Enter') { press(e); }
    });
    canvas.addEventListener('keyup', function (e) {
      if (e.code === 'Space' || e.code === 'ArrowUp' || e.code === 'Enter') release();
    });
    // While a run is active and the game is on screen, Space jumps even without focus.
    window.addEventListener('keydown', function (e) {
      if (document.activeElement === canvas) return;
      var tag = (e.target && e.target.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT|BUTTON/.test(tag)) return;
      if (state === 'run' && visible && (e.code === 'Space' || e.code === 'ArrowUp')) press(e);
    });
    window.addEventListener('keyup', function (e) {
      if (e.code === 'Space' || e.code === 'ArrowUp') release();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) resize();
        if (visible && state === 'run' && !raf) { last = performance.now(); raf = requestAnimationFrame(loop); }
      }, { threshold: 0.25 }).observe(wrap);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && state === 'run') visible = false;
      else if (!document.hidden) { visible = true; if (state === 'run' && !raf) { last = performance.now(); raf = requestAnimationFrame(loop); } }
    });

    var origCrash = crash;
    crash = function () { origCrash(); requestAnimationFrame(fadeFlash); };

    window.addEventListener('resize', resize);
    window.addEventListener('load', resize);
    reset();
    resize();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (state !== 'run') draw(); });
  }

  function prefillOptin() {
    var f = document.querySelector('[data-dd-optin-form]');
    if (!f) return;
    try {
      var email = sessionStorage.getItem('tr-dd-email');
      var input = f.querySelector('[name="contact[email]"]');
      if (email && input) input.value = email;
      var done = /on the list/i.test(f.textContent);
      if (!done && sessionStorage.getItem('tr-dd-optin') !== '1') f.hidden = true;
    } catch (e) {}
  }

  function boot() { document.querySelectorAll('[data-moto-game]').forEach(init); prefillOptin(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
